import { getPanoramaClient } from './panorama';

export const reportError = (thrown: unknown, attributes?: Record<string, unknown>) => {
  const error =
    thrown instanceof Error
      ? thrown
      : new Error(
          thrown && typeof thrown === 'object' && 'message' in thrown
            ? String(thrown.message)
            : `non-error exception: ${String(thrown)}`,
        );
  const httpError = thrown as
    | {
        requestId?: string;
        config?: { url?: string; method?: string };
        response?: { status?: number; statusText?: string };
      }
    | undefined;
  // Preserve trace metadata without serializing headers, bodies, or query parameters.
  const httpErrorDetails =
    httpError?.config || httpError?.response
      ? {
          requestId: httpError.requestId,
          requestConfig: httpError.config && {
            url: httpError.config.url?.split('?')[0],
            method: httpError.config.method,
          },
          response: httpError.response && {
            status: httpError.response.status,
            statusText: httpError.response.statusText,
          },
        }
      : undefined;
  getPanoramaClient()
    ?.errorMonitor()
    .reportError(error, {
      context: { ...attributes, ...(httpErrorDetails && { httpErrorDetails }) },
    });
};
